import './select-needed-bicycle-parts.modal.scss';

export default function SelectNeededBicyclePartsModal($scope, close, parts) {
  'ngInject';

  $scope.parts = [];

  const categories = [
    'LOCKS',
    'BRAKES',
    'BICYCLE_PARTS',
    'WHEEL_TIRES',
    'PARTS',
    'ARTS',
    'TOOLS',
    'OTHER'
  ];

  const builtCategories = [];
  categories.forEach(category => {
    const foundParts = parts.filter(p => p.category === category);
    if (foundParts.length > 0) {
      const expended = foundParts.filter(part => part.selected).length > 0;
      builtCategories.push({
        category: category,
        parts: foundParts,
        expended: expended
      });
    }
  })
  $scope.categories = builtCategories;

  $scope.close = () => {
    close();
  }

  $scope.ok = () => {
    const selectedParts = [];
    $scope.categories.forEach(cat => cat.parts
      .filter(part => part.selected)
      .forEach(part => selectedParts.push(part)));

    close(selectedParts);
  }
}